import { useState } from 'react';

export const useGlobalPopup = () => {
  const [popup, setPopup] = useState({
    isOpen: false,
    type: 'success',
    title: '',
    message: ''
  });

  const showPopup = (type, title, message) => {
    setPopup({
      isOpen: true,
      type,
      title,
      message
    });
  };

  const showSuccess = (title, message) => showPopup('success', title, message);
  const showError = (title, message) => showPopup('error', title, message);
  const showWarning = (title, message) => showPopup('warning', title, message);
  const showInfo = (title, message) => showPopup('info', title, message);

  // Create a custom alert function that uses popup
  const customAlert = (message, title = 'Alert') => {
    showInfo(title, message);
  };

  const closePopup = () => {
    setPopup({
      isOpen: false,
      type: 'success',
      title: '',
      message: ''
    });
  };

  return {
    popup,
    showPopup,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    customAlert,
    closePopup
  };
};